// Funzioni condivise dai controller del Cloud.

export function csrfToken() {
  return document.querySelector("meta[name='csrf-token']")?.content
}

// Gli elementi (tessere e righe) visibili nella vista corrente, nell'ordine visivo.
export function visibleItems(root) {
  return Array.from(root.querySelectorAll("[data-cloud-item]")).filter((el) => el.getClientRects().length > 0)
}

export function itemFromEvent(event) {
  return event.target.closest("[data-cloud-item]")
}

export function isFolder(item) {
  return item?.dataset.kind === "folder"
}

// Manda un form (o un url + FormData) chiedendo turbo-stream e applica la risposta.
export async function submitAsStream(url, { method = "POST", body, headers = {} } = {}) {
  const response = await fetch(url, {
    method,
    headers: { "X-CSRF-Token": csrfToken(), Accept: "text/vnd.turbo-stream.html, text/html", ...headers },
    body
  })
  const text = await response.text()
  if ((response.headers.get("Content-Type") || "").includes("turbo-stream")) window.Turbo.renderStreamMessage(text)
  return response
}

export function controllerFor(element, identifier) {
  return window.Stimulus?.getControllerForElementAndIdentifier(element, identifier)
}

// Toast minimale in basso a destra (successo o errore).
export function toast(message, { kind = "success", timeout = 4000 } = {}) {
  const el = document.createElement("div")
  el.className = `cloud-toast cloud-toast--${kind}`
  el.setAttribute("role", "status")
  el.textContent = message
  document.body.appendChild(el)
  requestAnimationFrame(() => el.classList.add("is-in"))
  setTimeout(() => { el.classList.remove("is-in"); setTimeout(() => el.remove(), 250) }, timeout)
  return el
}
